import { useContext, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../core/contexts/AuthContext";

type TProtectedRouteProps = {
    children: JSX.Element,
    allowedRoles: string[]
}

const ProtectedRoute = ({ children, allowedRoles }: TProtectedRouteProps) => {
    const { isInRole } = useContext(AuthContext);

    const [isAuthorized] = useState<boolean>(() => {
        let isAuth = false;
        for (const allowedRole of allowedRoles) {
            if (isInRole(allowedRole)) {
                isAuth = true;
                break;
            }
        }
        return isAuth;
    });

    return (
        <>
            {!isAuthorized ? (
                <Navigate to="not-authorized" replace={true} />
            ) : (
                <>{children}</>
            )}
        </>
    );
};

export default ProtectedRoute;
